// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"7179fca4","646":"e6914d69"}[chunkId] + ".chunk.js";
};